// EN
export const calendarHotel = {
  btn: {
    today: "Aujourd'hui",
  },
  summary: {
    availableLabel: "Disponible",
  },
  tooltip: {
    closed: "Fermé",
    dragToCreate: "Faites glisser pour sélectionner (créer une réservation)",
  },
  labels: {
    room: "chambre",
    rooms: "chambres",
    number: "NUMÉRO :",
    capacityIconAlt: "Capacité",
    maintenanceBadge: "MAINT.",
  },
  toasts: {
    reservationCreatedOk: "Réservation créée avec succès.",
    reservationCreateErrPrefix: "Impossible de créer la réservation : ",
    roomChangedOk: "Chambre modifiée avec succès",
    roomChangedErr: "Erreur lors du changement de chambre",
    roomTypeChangedOk: "La réservation passe en {type}",
  },
  warn: {
    selectTwoDays: "Sélectionnez au moins deux jours (arrivée et départ).",
  },
  errors: {
    closedForBooking: "Vous ne pouvez pas réserver une chambre ou un créneau fermé.",
    noAvailabilityTitle: "Aucune disponibilité",
    noAvailabilityDetail: "Aucune chambre de ce type n'est disponible à ces dates.",
    noRatesTitle: "Aucun tarif attribué",
    noRatesDetail: "Aucun tarif n'est disponible pour ce type à ces dates.",
    missingDataTitle: "Données manquantes",
    missingDataDetail: "Veuillez remplir tous les champs obligatoires.",
  },
  maintenanceModal: {
    titleFallback: "Chambre",
    statusSection: "Statut",
    closeForMaintenance: "Fermer pour maintenance",
    open: "Ouvrir",
    hint:
      "Lorsqu'une chambre est en maintenance, elle ne peut pas être vendue et ses cellules apparaissent en rouge. Les réservations existantes sont respectées.",
    actions: {
      cancel: "Annuler",
      save: "Enregistrer",
      saving: "Enregistrement…",
    },
  },

  // ===== NEW: Reservation modal =====
  modal: {
    title: "Enregistrer une nouvelle réservation",
    startDate: "Arrivée",
    endDate: "Départ",
    roomType: "Type de chambre",
    roomTypePlaceholder: "Sélectionner un type",
    quantity: "Nombre de chambres",
    available: "disponible",
    guestName: "Client responsable",
    guestNamePlaceholder: "Personne responsable de la réservation",
    guests: "Nombre de clients",
    guestsPlaceholder: "Nombre de clients",
    phone: "Téléphone",
    email: "E-mail",
    notes: "Note",
    notesPlaceholder: "Notes internes de la réservation (ex. arrivée tardive, lit bébé, allergies…)",
    addType: "Ajouter un autre type de chambre",
    price: "Prix",
    pricePlaceholder: "Saisir le prix",
    cancel: "Annuler",
    create: "Créer la réservation",
  },

  // ===== Validations =====
  validation: {
    minGuestsTitle: "Pas assez de clients",
    minGuestsDetail: "Il doit y avoir au moins {min} client(s) pour {rooms} chambre(s).",
    maxGuestsTitle: "Limite de clients dépassée",
    maxGuestsDetail: "Maximum {maxPerRoom} clients par chambre ({maxTotal} au total pour {rooms} chambres).",
    maxRoomsTitle: "Limite dépassée",
    maxRoomsDetail: "Vous ne pouvez pas réserver plus de {max} chambres.",
  },

  // ===== Promotions & Taxes =====
  promotions: {
    limitTitle: "Limite atteinte",
    limitDetail: "Vous ne pouvez pas ajouter plus d'une promotion.",
  },
  taxes: {
    limitTitle: "Limite atteinte",
    limitDetail: "Vous ne pouvez pas ajouter plus d'une taxe.",
  },
};
